import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import * as actions from "../../../store/actions/index";
import axios from "../../../axios-url";
// import "./KOTCommon.scss";

// ============================================================================
// WaiterDashboard — Waiter / Captain page
// One card per ORDER (requestid), combining every kitchen station that fed
// into it. A waiter/captain tracks the whole table's order together,
// regardless of how many kitchen stations are cooking it. Row tap only
// moves an item between Pending and Preparing. Reaching Ready is a
// deliberate, manual action via the checkbox — never automatic.
// ============================================================================

const toggleKitchenStage = (s) => (s === "pending" ? "preparing" : "pending");

// ⚠️ statusId -> stage mapping. Sample payload has statusId: null, so this
// is a placeholder — replace the numeric keys with your real status-master
// IDs for Pending / Preparing / Ready once confirmed.
const STATUS_ID_TO_STAGE = {
  1: "pending",
  2: "preparing",
  3: "ready",
};

// const READY_STATUS_ID = 14;
const READY_STATUS_ID = 14;
const PREPARING_STATUS_ID = 11;
const UPDATE_READY_STATUS_ID = 1999; // KOT served

const DINE_IN_ORDER_TYPE = "550e8400-e29b-41d4-a716-446655440001";
// The waiter's job is Ready (14) -> Served (999). Only a SERVED item is done
// here: a Ready one is exactly what the waiter still has to act on. Item
// status "ready" below is this screen's name for done, i.e. served.
// 1999 is the served status; 999 is what this screen wrote before, kept so
// items served back then still read as served.
const SERVED_STATUS_IDS = [1999, 999];

const formatApiTime = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

// ─── Order ageing → header colour ───────────────────────────────────────────
// Same clock as the Kitchen and Packing screens: the OLDEST item's targetdate
// (createddate as fallback). The API sends UTC without a trailing "Z".
const earliestTargetTime = (items) =>
  Math.min(
    ...items.map((it) => {
      const raw = it.targetdate || it.createddate || "";
      const ts = new Date(/Z$|[+-]\d{2}:?\d{2}$/.test(raw) ? raw : `${raw}Z`).getTime();
      return ts || Number.MAX_SAFE_INTEGER;
    })
  );

const orderUrgency = (items) => {
  const elapsedMinutes = (Date.now() - earliestTargetTime(items)) / 60000;
  if (elapsedMinutes > 10) return "late";
  if (elapsedMinutes > 5) return "warn";
  return "";
};

// Used to label which kitchen-station KOT each item came from, so a waiter
// card can list "Includes: KOT-101, KOT-102".
const kotStationKey = (r) =>
  r.kotnumber || `${r.requestid}-${r.menuitemkitchenid || r.kitchenid || "default"}`;

// One row from GetresActionAllList -> one item. This is the SINGLE source of
// truth this page works off.
const mapActionsToItems = (records, menuItems) => {
  if (!Array.isArray(records)) return [];

  return records
    .filter((r) => r.menuId !== null && r.menuId !== undefined)
    // Kitchen rows only: bill/payment/packing rows repeat the same menu items
    // and never reach the served status, so they would pin an order here.
    .filter((r) => Number(r.actiontype) === 1)
    // Waiters only serve Dine In; Takeaway/Delivery go to Packing instead.
    .filter((r) => String(r.ordertype).toLowerCase() === DINE_IN_ORDER_TYPE)
    .map((r) => {

      const isWaiterDineIn =
        Number(r.actiontype) === 1 &&
        String(r.ordertype) === "550e8400-e29b-41d4-a716-446655440001";

      // const isReady =
      //   isWaiterDineIn &&
      //   Number(r.statusId) === READY_STATUS_ID;

      // const isReady =
      //   isWaiterDineIn &&
      //   SERVED_STATUS_IDS.includes(Number(r.statusId));

      const isReady =
        SERVED_STATUS_IDS.includes(Number(r.statusId));

      const isPreparing =
        isWaiterDineIn &&
        Number(r.statusId) === 11;

      const menu = menuItems.find(
        (x) =>
          String(x.value) === String(r.menuId) ||
          String(x.id) === String(r.menuId) ||
          String(x.menuId) === String(r.menuId)
      );


      // const isReady =
      //   r.statusId !== null &&
      //   r.statusId !== undefined &&
      //   Number(r.statusId) === READY_STATUS_ID;

      // return {
      //   ...r,
      //   id: r.requestactionid,
      //   requestId: r.requestid,
      //   kotKey: kotStationKey(r),
      //   kotNo: r.kotnumber,
      //   tableNo: r.tablenumber,
      //   tokenNo: r.tokennumber,
      //   createdTime: formatApiTime(r.createddate),
      //   actiontype: r.actiontype,
      //   menuId: r.menuId,
      //   name: menu?.label || menu?.name || menu?.menuName || menu?.text || `Menu ${r.menuId}`,
      //   qty: r.menuQty || 1,
      //   status: isReady ? "ready" : STATUS_ID_TO_STAGE[r.statusId] || "pending",
      //   statusId: r.statusId,
      //   selected: isReady,
      // };

      // return {
      //   ...r,

      //   id: r.requestactionid,

      //   // Order Number should display Request ID
      //   requestId: r.requestid,

      //   kotKey: kotStationKey(r),

      //   kotNo: r.kotnumber,

      //   tableNo: r.tablenumber,

      //   tokenNo: r.tokennumber,

      //   createdTime: formatApiTime(r.createddate),

      //   actiontype: r.actiontype,

      //   menuId: r.menuId,


      //   // Menu Item label display
      //   name:
      //     menu?.label ||
      //     menu?.name ||
      //     menu?.menuName ||
      //     menu?.text ||
      //     `Menu ${r.menuId}`,


      //   qty: r.menuQty || 1,


      //   status:
      //     isReady
      //       ? "ready"
      //       : isPreparing
      //         ? "not-ready"
      //         : STATUS_ID_TO_STAGE[r.statusId] || "pending",


      //   statusId: r.statusId,

      //   selected: isReady,
      // };

      const hasMenuItem = !!menu;

      return {
        ...r,

        id: r.requestactionid,

        requestId: r.requestid,

        kotKey: kotStationKey(r),

        kotNo: r.kotnumber,

        tableNo: r.tablenumber,

        tokenNo: r.tokennumber,

        createdTime: formatApiTime(r.createddate),

        actiontype: r.actiontype,

        menuId: r.menuId,

        // Show menu label only if menu exists
        name: hasMenuItem
          ? (
            menu.label ||
            menu.name ||
            menu.menuName ||
            menu.text
          )
          : "",


        qty: r.menuQty || 1,


        // status:
        //   isReady
        //     ? "ready"
        //     : isPreparing
        //       ? "not-ready"
        //       : STATUS_ID_TO_STAGE[r.statusId] || "pending",

        status:
          isReady
            ? "ready"
            : Number(r.statusId) === READY_STATUS_ID
              ? "pending"
              : "not-ready",

        statusId: r.statusId,

        selected: isReady,
      };
    });
};

// Group by requestid ONLY — a waiter tracks the whole table's order
// together, regardless of how many kitchen stations are cooking it.
// relatedKots lists every KOT number that fed into this order, so the
// waiter can cross-check with the kitchen (e.g. "KOT-101, KOT-102").
const groupItemsByOrder = (items) => {
  const grouped = items.reduce((acc, it) => {
    if (!acc[it.requestId]) {
      acc[it.requestId] = {
        key: it.requestId,
        groupType: "order",
        kotNo: it.ptsjrsr || `Order-${String(it.requestId).slice(0, 6)}`,
        tableNo: it.tableNo,
        tokenNo: it.tokenNo,
        actiontype: it.actiontype,
        createdTime: it.createdTime,
        relatedKots: new Set(),
        items: [],
      };
    }
    acc[it.requestId].relatedKots.add(it.kotNo);
    acc[it.requestId].items.push(it);
    return acc;
  }, {});
  // Oldest target time first, so the longest-waiting order leads the grid.
  return Object.values(grouped)
    .map((o) => ({
      ...o,
      relatedKots: Array.from(o.relatedKots),
    }))
    .sort((a, b) => earliestTargetTime(a.items) - earliestTargetTime(b.items));
};


class WaiterDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      hiddenReadyItems: [],
      currentTime: this._formatTime(new Date()),
      readyReloadHandled: false,

    };
  }

  componentDidMount() {
    this._clockInterval = setInterval(() => {
      this.setState({ currentTime: this._formatTime(new Date()) });
    }, 30000);

    this.props.loadKotActions();
    this._stopKotLive = this.props.startKotActionsLive();
    this.props.getMasterKeywordList("MenuItem");
  }

  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps.tableLists !== this.props.tableLists ||
  //     prevProps.MenuItem !== this.props.MenuItem
  //   ) {
  //     if (!Array.isArray(this.props.tableLists) || this.props.tableLists.length === 0) {
  //       return;
  //     }

  //     const mappedItems = mapActionsToItems(this.props.tableLists, this.props.MenuItem);

  //     // this.setState({ items: mappedItems }, () => {
  //     //   this.removeReadyKotsAfterReload(mappedItems);
  //     // });
  //     this.setState({ items: mappedItems }, () => {
  //       this.handleReadyItemsAfterReload(mappedItems);
  //     });
  //   }
  // }

  componentDidUpdate(prevProps) {

    if (
      prevProps.tableLists !== this.props.tableLists ||
      prevProps.MenuItem !== this.props.MenuItem
    ) {

      if (
        !Array.isArray(this.props.tableLists) ||
        this.props.tableLists.length === 0
      ) {
        return;
      }


      const mappedItems = mapActionsToItems(
        this.props.tableLists,
        this.props.MenuItem
      );

      const filteredItems = this.removeAlreadyCompletedOrders(mappedItems);

      this.setState(
        {
          items: filteredItems,
          readyReloadHandled: false
        },
        () => {
          if (!this.state.readyReloadHandled) {
            this.handleReadyItemsAfterReload(filteredItems);
          }
        }
      );

      // this.setState(
      //   {
      //     items: mappedItems,
      //     readyReloadHandled: false
      //   },
      //   () => {

      //     if (!this.state.readyReloadHandled) {
      //       this.handleReadyItemsAfterReload(mappedItems);
      //     }

      //   }
      // );
    }
  }
  // removeAlreadyCompletedOrders = (items) => {

  //   const groupedOrders = groupItemsByOrder(items);

  //   const completedOrderIds = groupedOrders
  //     .filter(group =>
  //       group.items.every(item =>
  //         SERVED_STATUS_IDS.includes(Number(item.statusId))
  //       )
  //     )
  //     .map(group => group.key);


  //   return items.filter(
  //     item => !completedOrderIds.includes(item.requestId)
  //   );
  // };

  removeAlreadyCompletedOrders = (items) => {

    const groupedOrders = groupItemsByOrder(items);

    const completedOrderIds = groupedOrders
      .filter(group => {

        return group.items.length > 0 &&
          group.items.every(item =>
            SERVED_STATUS_IDS.includes(Number(item.statusId))
          );

      })
      .map(group => group.key);


    return items.filter(
      item => !completedOrderIds.includes(item.requestId)
    );
  };
  componentWillUnmount() {
    clearInterval(this._clockInterval);
    if (this._stopKotLive) this._stopKotLive();
  }

  _formatTime(d) {
    return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  }

  // Tapping the row body cycles Pending ↔ Preparing only.
  // handleItemStatusChange = (itemId) => {
  //   this.setState((prev) => ({
  //     items: prev.items.map((it) => {
  //       if (it.id !== itemId || it.status === "ready") return it;
  //       const nextStatus = toggleKitchenStage(it.status);
  //       // TODO: persist statusId back to the API, e.g.
  //       // this.props.updateRequestActionStatus(it.id, nextStatus);
  //       return { ...it, status: nextStatus };
  //     }),
  //   }));
  // };

  handleItemStatusChange = (itemId) => {
    this.setState((prev) => ({
      items: prev.items.map((it) => {

        // Ready and Not Ready items should not change
        if (
          it.id !== itemId ||
          it.status === "ready" ||
          it.status === "not-ready"
        ) {
          return it;
        }

        const nextStatus = toggleKitchenStage(it.status);

        return {
          ...it,
          status: nextStatus,
        };
      }),
    }));
  };

  handleSelectAll = (groupType, groupKey, checked) => {
    this.setState((prev) => ({
      items: prev.items.map((it) => {
        const matches = groupType === "kot" ? it.kotKey === groupKey : it.requestId === groupKey;
        if (!matches) return it;
        // Only kitchen-ready items can be served; served and not-ready ones stay as they are.
        return it.status === "ready" || it.status === "not-ready" ? it : { ...it, selected: checked };
      }),
    }));
  };

  handleReadyToggle = (itemId, checked) => {
    this.setState((prev) => ({
      items: prev.items.map((it) => {

        // After Mark Ready, checkbox cannot be changed
        if (
          it.id === itemId &&
          SERVED_STATUS_IDS.includes(Number(it.statusId))
        ) {
          return it;
        }

        return it.id !== itemId
          ? it
          : {
            ...it,
            selected: checked,
          };
      }),
    }));
  };

  // handleCollectiveReady = async (groupType, groupKey) => {
  //   const selectedItems = this.state.items.filter((it) => {
  //     const matches = groupType === "kot" ? it.kotKey === groupKey : it.requestId === groupKey;
  //     return matches && it.selected;
  //   });

  //   if (selectedItems.length === 0) return;

  //   try {
  //     const data = selectedItems.map((item) => {
  //       const {
  //         id,
  //         requestId,
  //         kotKey,
  //         kotNo,
  //         tableNo,
  //         tokenNo,
  //         createdTime,
  //         name,
  //         qty,
  //         status,
  //         selected,
  //         ...backendData
  //       } = item;

  //       // return {
  //       //   ...backendData,
  //       //   // update only status
  //       //   statusId: READY_STATUS_ID,
  //       // };

  //       return {
  //         ...backendData,
  //         actiontype: 1, // Waiter action type

  //         // temporary update status
  //         statusId: UPDATE_READY_STATUS_ID,
  //       };
  //     });

  //     await axios.post("/master/api/UpdateDynamicData?model=Restaurant_Action_Update", {
  //       Key: JSON.stringify(data),
  //     });

  //     // this.setState(
  //     //   (prev) => ({
  //     //     items: prev.items.map((it) => {
  //     //       const match = selectedItems.find((x) => x.id === it.id);
  //     //       if (!match) return it;
  //     //       return { ...it, status: "ready", statusId: READY_STATUS_ID, selected: false };
  //     //     }),
  //     //   }),
  //     //   () => {
  //     //     this.removeCompletedKot(groupType, groupKey);
  //     //   }
  //     // );

  //     // this.setState(
  //     //   (prev) => ({
  //     //     items: prev.items.map((it) => {
  //     //       const match = selectedItems.find((x) => x.id === it.id);

  //     //       if (!match) return it;

  //     //       return {
  //     //         ...it,
  //     //         status: "ready",
  //     //         statusId: UPDATE_READY_STATUS_ID,
  //     //         selected: true,
  //     //       };
  //     //     }),
  //     //   }),
  //     //   () => {

  //     //     // hide temporarily
  //     //     setTimeout(() => {

  //     //       this.setState((prev) => ({
  //     //         items: prev.items.map((it) => {

  //     //           const match = selectedItems.find(
  //     //             (x) => x.id === it.id
  //     //           );

  //     //           if (!match) return it;

  //     //           return {
  //     //             ...it,
  //     //             selected: false
  //     //           };

  //     //         })
  //     //       }));

  //     //     }, 2000);

  //     //   }
  //     // );

  //     setTimeout(() => {

  //       this.setState((prev) => ({
  //         hiddenReadyItems:
  //           prev.hiddenReadyItems.filter(
  //             id => !selectedItems.some(x => x.id === id)
  //           )
  //       }));

  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  handleCollectiveReady = async (groupType, groupKey) => {
    const selectedItems = this.state.items.filter((it) => {
      const matches =
        groupType === "kot"
          ? it.kotKey === groupKey
          : it.requestId === groupKey;

      // Already-served items show ticked but are not sent again.
      return matches && it.selected && !SERVED_STATUS_IDS.includes(Number(it.statusId));
    });

    if (selectedItems.length === 0) return;

    try {
      const data = selectedItems.map((item) => {
        const {
          id,
          requestId,
          kotKey,
          kotNo,
          tableNo,
          tokenNo,
          createdTime,
          name,
          qty,
          status,
          selected,
          ...backendData
        } = item;

        return {
          ...backendData,

          actiontype: 1,

          // Keep existing status
          // statusId: item.statusId,
          statusId: UPDATE_READY_STATUS_ID,

        };
      });


      await axios.post(
        "/master/api/UpdateDynamicData?model=Restaurant_Action_Update",
        {
          Key: JSON.stringify(data),
        }
      );


      // Hide selected items temporarily
      // this.setState(
      //   (prev) => ({
      //     hiddenReadyItems: [
      //       ...prev.hiddenReadyItems,
      //       ...selectedItems.map((item) => item.id),
      //     ],

      //     // remove checkbox selection only
      //     items: prev.items.map((it) => {
      //       const selectedItem = selectedItems.find(
      //         (x) => x.id === it.id
      //       );

      //       if (!selectedItem) return it;

      //       return {
      //         ...it,
      //         selected: false,
      //       };
      //     }),
      //   }),
      //   () => {

      //     // Show items again after 2 seconds
      //     setTimeout(() => {

      //       this.setState((prev) => ({
      //         hiddenReadyItems:
      //           prev.hiddenReadyItems.filter(
      //             (id) =>
      //               !selectedItems.some(
      //                 (item) => item.id === id
      //               )
      //           ),
      //       }));

      //     }, 2000);


      //     // Check if complete order is ready
      //     this.removeCompletedKot(groupType, groupKey);

      //   }
      // );

      this.setState(
        (prev) => ({
          hiddenReadyItems: [
            ...prev.hiddenReadyItems,
            ...selectedItems.map((x) => x.id),
          ],
          // items: prev.items.map((it) =>
          //   selectedItems.some((x) => x.id === it.id)
          //     ? {
          //       ...it,
          //       statusId: UPDATE_READY_STATUS_ID,
          //       selected: true,
          //     }
          //     : it
          // ),
          items: prev.items.map((it) =>
            selectedItems.some((x) => x.id === it.id)
              ? {
                ...it,
                status: "ready",
                statusId: UPDATE_READY_STATUS_ID,
                selected: true,
              }
              : it
          ),
        }),
        () => {
          // Remove the entire order only if all items are ready
          // this.removeReadyOrdersAfterReload(this.state.items);
          setTimeout(() => {
            this.removeReadyOrdersAfterReload(this.state.items);
          }, 100);

          // Show hidden items again after 2 seconds
          setTimeout(() => {
            this.setState((prev) => ({
              hiddenReadyItems: prev.hiddenReadyItems.filter(
                (id) => !selectedItems.some((x) => x.id === id)
              ),
            }));
          }, 2000);
        }
      );


    } catch (err) {
      console.log(err);
    }
  };
  removeCompletedKot = (groupType, groupKey) => {
    const groupItems = this.state.items.filter((item) =>
      groupType === "kot" ? item.kotKey === groupKey : item.requestId === groupKey
    );

    const allReady = groupItems.every((item) => item.status === "ready");
    if (!allReady) return;

    setTimeout(() => {
      this.setState((prev) => ({
        items: prev.items.filter((item) =>
          groupType === "kot" ? item.kotKey !== groupKey : item.requestId !== groupKey
        ),
      }));
    }, 5000);
  };


  // handleReadyItemsAfterReload = (items) => {

  //   const readyItems = items.filter((item) =>
  //     SERVED_STATUS_IDS.includes(Number(item.statusId))
  //   );

  //   if (readyItems.length === 0) return;


  //   // hide ready items temporarily
  //   const readyIds = readyItems.map(item => item.id);


  //   this.setState({
  //     hiddenReadyItems: readyIds
  //   });


  //   // show again after 2 seconds
  //   setTimeout(() => {

  //     this.setState({
  //       hiddenReadyItems: []
  //     });

  //   }, 2000);


  //   // remove only when complete group is ready
  //   this.removeReadyKotsAfterReload(items);
  // };

  // handleReadyItemsAfterReload = (items) => {

  //   const readyItems = items.filter((item) =>
  //     SERVED_STATUS_IDS.includes(Number(item.statusId))
  //   );


  //   if (readyItems.length === 0) return;


  //   const readyIds = readyItems.map(item => item.id);


  //   // hide ready items
  //   this.setState({
  //     hiddenReadyItems: readyIds,
  //     readyReloadHandled: true
  //   });


  //   // show again after 2 seconds
  //   setTimeout(() => {

  //     this.setState({
  //       hiddenReadyItems: []
  //     });

  //   });


  //   // remove full ready order only
  //   this.removeReadyKotsAfterReload(items);
  // };
  handleReadyItemsAfterReload = (items) => {

    const readyIds = items
      .filter(item => SERVED_STATUS_IDS.includes(Number(item.statusId)))
      .map(item => item.id);


    if (readyIds.length === 0) return;


    // Hide only ready items temporarily
    this.setState({
      hiddenReadyItems: readyIds,
      readyReloadHandled: true
    });


    // Show items again after 2 seconds
    setTimeout(() => {

      this.setState({
        hiddenReadyItems: []
      });

    });


    // Check full order ready
    this.removeReadyOrdersAfterReload(items);
  };

  // removeReadyKotsAfterReload = (items) => {
  //   const readyGroups = {};

  //   items.forEach((item) => {
  //     // if (Number(item.statusId) === READY_STATUS_ID) {
  //     if (SERVED_STATUS_IDS.includes(Number(item.statusId))) {
  //       if (!readyGroups[item.kotKey]) readyGroups[item.kotKey] = [];
  //       readyGroups[item.kotKey].push(item);
  //     }
  //   });

  //   Object.keys(readyGroups).forEach((key) => {
  //     const groupItems = items.filter((item) => item.kotKey === key);
  //     // const allReady = groupItems.every((item) => Number(item.statusId) === READY_STATUS_ID);
  //     const allReady = groupItems.every(
  //       (item) => SERVED_STATUS_IDS.includes(Number(item.statusId))
  //     );

  //     if (allReady) {
  //       setTimeout(() => {
  //         this.setState((prev) => ({
  //           items: prev.items.filter((item) => item.kotKey !== key),
  //         }));
  //       });
  //     }
  //   });
  // };

  removeReadyOrdersAfterReload = (items) => {

    const groupedOrders = groupItemsByOrder(items);


    groupedOrders.forEach((group) => {

      const allReady = group.items.every(item =>
        SERVED_STATUS_IDS.includes(Number(item.statusId))
      );


      if (allReady) {

        setTimeout(() => {

          this.setState(prev => ({
            items: prev.items.filter(
              item => item.requestId !== group.key
            )
          }));

        });

      }

    });

  };
  renderKOTCard = (group) => {
    // const allReady = group.items.every((i) => i.status === "ready");
    const allReady = group.items.every((i) =>
      SERVED_STATUS_IDS.includes(Number(i.statusId))
    );

    return (
      <div key={group.key} className="kot-card">
        <div className={`kot-card__header kot-card__header--${orderUrgency(group.items)}`}>
          <div className="kot-card__header-top">
            <span className="kot-card__kot-no">{group.kotNo}</span>
            <small className="kot-card__time">
              <i className="pi pi-clock p-mr-1" />
              {group.createdTime}
            </small>
          </div>

          <div className="kot-card__meta">
            {group.tableNo && (
              <>
                Table {group.tableNo} <span className="dot">&middot;</span>
              </>
            )}
            Token {group.tokenNo}
          </div>

          {group.relatedKots && group.relatedKots.length > 0 && (
            <div className="kot-card__related">
              <i className="pi pi-link p-mr-1" />
              Includes: {group.relatedKots.join(", ")}
            </div>
          )}
        </div>

        <div className="kot-card__items">
          <div className="kot-select-all">
            <span className="kot-select-all-label">Select All</span>

            <Checkbox
              checked={
                group.items.filter((item) => item.status !== "ready" && item.status !== "not-ready").length > 0 &&
                group.items
                  .filter((item) => item.status !== "ready" && item.status !== "not-ready")
                  .every((item) => item.selected)
              }
              onChange={(e) => this.handleSelectAll(group.groupType, group.key, e.checked)}
              className="kot-select-all-checkbox"
            />
          </div>

          {/* {group.items.map((item) => { */}
          {group.items
            .filter(item => !this.state.hiddenReadyItems.includes(item.id))
            .map((item) => {
              const isDone = item.status === "ready";
              const isSelected = item.selected || false;

              return (
                <div
                  key={item.id}
                  className={`kot-item-row ${isDone ? "kot-item-row--done" : ""}`}
                  // onClick={() => !isDone && this.handleItemStatusChange(item.id)}
                  onClick={() =>
                    !isDone &&
                    item.status !== "not-ready" &&
                    this.handleItemStatusChange(item.id)
                  }
                >
                  <span className="kot-item-qty">&times;{item.qty}</span>

                  <span className={`kot-item-name ${isDone ? "kot-item-name--done" : ""}`}>
                    {item.name}
                  </span>

                  {/* <span
                  className={`kot-ready-pill ${isDone ? "kot-ready-pill--active" : ""}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className={`kot-ready-label ${isDone ? "kot-ready-label--active" : ""}`}>
                    Ready
                  </span>
                  <Checkbox
                    checked={isDone || isSelected}
                    disabled={isDone}
                    onChange={(e) => this.handleReadyToggle(item.id, e.checked)}
                    className="kot-ready-check"
                  />
                </span> */}

                  {
                    item.status === "not-ready" ? (

                      <span className="kot-not-ready-label">
                        Not Ready
                      </span>

                    ) : (

                      <span
                        className="kot-ready-pill kot-ready-pill--active"
                        onClick={(e) => e.stopPropagation()}
                      >

                        <span className="kot-ready-label kot-ready-label--active">
                          {isDone ? "Served" : "Ready"}
                        </span>

                        {/* <Checkbox
                          checked={isDone || isSelected}
                          disabled={false}
                          onChange={(e) =>
                            this.handleReadyToggle(item.id, e.checked)
                          }
                          className={`kot-ready-check ${isDone || isSelected ? "kot-ready-check-active" : ""}`}
                        /> */}
                        <Checkbox
                          checked={isDone || isSelected}
                          disabled={
                            SERVED_STATUS_IDS.includes(Number(item.statusId))
                          }
                          onChange={(e) =>
                            this.handleReadyToggle(item.id, e.checked)
                          }
                          className={`kot-ready-check ${isDone || isSelected ? "kot-ready-check-active" : ""
                            }`}
                        />
                      </span>

                    )
                  }
                </div>
              );
            })}
        </div>

        <div className="kot-card__footer">
          {allReady ? (
            <span className="kot-all-ready-badge">
              <i className="pi pi-check-circle" />
              All served
            </span>
          ) : (
            <Button
              label="Mark Served"
              className="p-button-sm kot-mark-ready-btn"
              onClick={() => this.handleCollectiveReady(group.groupType, group.key)}
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { items, currentTime } = this.state;
    const orderGroups = groupItemsByOrder(items);

    return (
      <div className="kot-dashboard-root">
        {this.props.loading && <div className="page-loader"></div>}
        {this.props.error !== null && this.props.error !== undefined && (
          <div className="p-error" style={{ padding: "0.5em 1em" }}>
            {this.props.error}
          </div>
        )}

        <div className="kot-page-header">
          <div className="kot-page-header__brand">
            <div className="kot-page-header__title-row">
              <i className="pi pi-user kot-page-header__icon" />
              <h2 className="kot-page-header__title">Waiter</h2>
              <span className="kot-tab-count kot-tab-count--active">{orderGroups.length}</span>
            </div>
          </div>
          <small className="kot-page-header__time">
            <i className="pi pi-clock p-mr-1" />
            {currentTime}
          </small>
        </div>

        {orderGroups.length === 0 ? (
          <div className="kot-empty-state">
            <i className="pi pi-inbox kot-empty-state__icon" />
            <span className="p-text-secondary">No active Orders</span>
          </div>
        ) : (
          <div className="kot-card-grid">{orderGroups.map(this.renderKOTCard)}</div>
        )}
      </div>
    );
  }
}

// ─── Redux wiring ─────────────────────────────────────────────────────────────
const mapStateToProps = (state) => ({
  loading: state.master.loading,
  error: state.master.error,
  success: state.master.success,
  // The action list has its own store slot, kept live by startKotActionsLive.
  tableLists: state.master.kotActions,
  menuItems: state.keyword.keywordList,
  MenuItem: state.keyword.MenuItem !== undefined ? state.keyword.MenuItem : [],
});

const mapDispatchToProps = (dispatch) => ({
  getMasterTableList: (table, company) => dispatch(actions.getMasterTableList(table, company)),
  loadKotActions: () => dispatch(actions.loadKotActions()),
  startKotActionsLive: () => dispatch(actions.startKotActionsLive()),
  getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
  // TODO: once you have a real "update status" endpoint, wire it here.
});

export default connect(mapStateToProps, mapDispatchToProps)(WaiterDashboard);